var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-dialog',{attrs:{"value":_vm.$wait.is('busy'),"content":"","content-class":"centered-dialog","persistent":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }